import { types, flow } from 'mobx-state-tree'

import buildPersistedChangesStore from '~/stores/models/persistedChanges'
import buildCustomValidationStore from '~/stores/models/customValidation'
import * as DivorceService from '~/services/divorce'
import DIVORCE_CASE_VALIDATIONS from '~/utilities/divorceCaseValidations'

const DivorceFetcherCaseBase = types
  .model('DivorceFetcherCase', {
    caseId: types.optional(types.string, ''),
    url: types.optional(types.string, ''),
    receivedDate: types.optional(types.string, ''),
    status: types.optional(types.string, ''),
    eFilingStatus: types.optional(types.string, ''),
    caption: types.optional(types.string, ''),
    fullCaption: types.optional(types.string, ''),
    court: types.optional(types.string, ''),
    type: types.optional(types.string, ''),
    files: types.array(types.frozen({}), ''),
    petitioners: types.array(types.frozen({})),
    respondents: types.array(types.frozen({})),
  })
  .views((self) => ({
    get receivedDateObject() {
      return self.receivedDate && new Date(self.receivedDate)
    }
  }))
  .actions((self) => ({
    createCase: flow(function* createCase(keys, origin) {
      const data = self.buildDataObject(keys)
      data.telemetry = {
        origin_create: `v2 web app${origin ? ` - ${origin}` : ''}`,
      }

      return yield DivorceService.create(data)
    }),
    updateCase: flow(function* updateCase(keys, sessionToken) {
      const data = self.buildDataUpdateObject(keys)

      if (!data) return true

      yield DivorceService.update(self.objectId, data, sessionToken)
      return true
    }),
  }))

const PersistedChangesStore = buildPersistedChangesStore({
  keyTransformer: (self, key) => self[key],
})

const CustomValidationStore = buildCustomValidationStore({
  validationObject: DIVORCE_CASE_VALIDATIONS,
})

const DivorceFetcherCase = types.compose(
  DivorceFetcherCaseBase,
  PersistedChangesStore,
  CustomValidationStore,
)
export default DivorceFetcherCase
